import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  languageLoadGuard,
  authGuard,
  verifiedPersonGuard,
  unauthenticatedGuard,
  assessmenttokenGuard,
  hasProfilePicture,
  hasLanguagePreference,
  breakGuard,
  speedTestGuard
} from "./guards";
import multiGuard from 'vue-router-multiguard';
import store from "../store";

Vue.use(VueRouter);

const routes = [
  //Home
  {
    path: '/',
    name: 'Home',
    beforeEnter: multiGuard([languageLoadGuard]),
    component: () => import('../views/Home.vue')
  },
  {
    path: '/test/video',
    name: 'NetworkVideoTest',
    beforeEnter: multiGuard([languageLoadGuard]),
    component: () => import('../views/Test/NetworkVideoTest.vue')
  },
  {
    path: '/start/:token',
    name: 'TokenStart',
    beforeEnter: multiGuard([languageLoadGuard]),
    component: () => import('../views/Start/TokenStart.vue')
  },
  {
    path: '/inject/:assessmentid/:token',
    name: 'JwtInject',
    beforeEnter: multiGuard([languageLoadGuard]),
    component: () => import('../views/Start/JwtInject.vue')
  },
  {
    path: '/error',
    name: 'Error',
    props: true,
    component: () => import('../views/Error/Error.vue')
  },
  {
    path: '/login',
    name: 'Login',
    props: true,
    beforeEnter: multiGuard([languageLoadGuard, unauthenticatedGuard]),
    component: () => import('../views/Auth/Login.vue')
  },
  {
    path: '/logintoken',
    name: 'LoginWithToken',
    props: true,
    beforeEnter: multiGuard([languageLoadGuard, unauthenticatedGuard, assessmenttokenGuard]),
    component: () => import('../views/Auth/LoginWithToken.vue')
  },
  {
    path: '/register',
    name: 'Register',
    props: true,
    beforeEnter: authGuard,
    component: () => import('../views/Auth/Register.vue')
  },
  {
    path: '/break',
    name: 'Break',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard]),
    component: () => import('../views/General/OnBreak.vue')
  },
  {
    path: '/register/info',
    name: 'RegisterPersonInfo',
    props: true,
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard]),
    component: () => import('../views/Register/PersonInfo.vue')
  },
  {
    path: '/language',
    name: 'Language',
    props: true,
    beforeEnter: authGuard,
    component: () => import('../views/General/PreferredLanguage.vue')
  },
  {
    path: '/register/picture',
    name: 'RegisterProfilePicture',
    props: true,
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference]),
    component: () => import('../views/Register/ProfilePic.vue')
  },
  {
    path: '/connection',
    name: 'SpeedTest',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference]),
    component: () => import('../views/General/ConnectionSpeed.vue')
  },
  {
    path: '/orientation',
    name: 'OrientationVideo',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference]),
    component: () => import('../views/General/OrientationVideo.vue')
  },
  {
    path: '/devicecheck',
    name: 'DeviceCheck',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference]),
    component: () => import('../views/General/DeviceCheck.vue')
  },
  {
    path: '/miccheck',
    name: 'MicCheck',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference]),
    component: () => import('../views/General/MicCheck.vue')
  },
  {
    path: '/soundcheck',
    name: 'SoundCheck',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference]),
    component: () => import('../views/General/SoundCheck.vue')
  },
  {
    path: '/networkvideocheck',
    name: 'NetworkVideoCheck',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference]),
    component: () => import('../views/General/NetworkVideoCheck.vue')
  },
  {
    path: '/journey/orientation',
    name: 'JourneyOrientation',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference, hasProfilePicture, speedTestGuard]),
    component: () => import('../views/Journey/Orientation.vue')
  },
  {
    path: '/journey',
    name: 'Journey',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference, hasProfilePicture, speedTestGuard]),
    component: () => import('../views/Journey/Journey.vue')
  },
  {
    path: '/journey/plan',
    name: 'Plan',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference, hasProfilePicture]),
    component: () => import('../views/Journey/JourneyProgressPlan.vue')
  },
  {
    path: '/users/profile',
    name: 'UserProfile',
    beforeEnter: multiGuard([authGuard, verifiedPersonGuard, breakGuard, hasLanguagePreference, hasProfilePicture]),
    component: () => import('../views/Profile/UserProfile.vue'),
  },
   {
     path: '/dev/',
     name: 'Dev',
     component: () => import('../views/Dev/Dev.vue')
   },
  /*
{
  path: '/charts',
  name: 'Charts',
  component: () => import('../views/Dev/Charts.vue')
},
{
      path: '/audio',
      name: 'Audio',
      component: () => import('../views/Dev/Audio.vue')
  },{
      path: '/twilio',
      name: 'twilio',
      component: () => import('../views/Dev/Webcam.vue')
  },

  {
      path: '/questions',
      name: 'Questions',
      component: () => import('../views/Dev/Questions.vue')
  },
  {
      path: '/loading',
      name: 'StartLoading',
      component: () => import('../views/Start/LoadingStart.vue')
  },

  //Welcome


  {
      path: '/welcome/webcam',
      name: 'WebcamTest',
      component: () => import('../views/Welcome/WebcamTest.vue')
  },
  {
      path: '/welcome/microphone',
      name: 'MicrophoneTest',
      component: () => import('../views/Welcome/MicrophoneTest.vue')
  },
  {
      path: '/welcome/complete',
      name: 'TestsCompleted',
      component: () => import('../views/Welcome/TestsCompleted.vue'),
  },

  //Journey
{
  path: '/users/profile/achievement',
  name: 'UserAchievement',
  beforeEnter: multiGuard([authGuard, verifiedPersonGuard, hasLanguagePreference, hasProfilePicture]),
  component: () => import('../views/Dev/UserAchievement.vue')
},

{
  path: '/test/monitor',
  name: 'TestMonitoring',
  component: () => import('../views/Dev/TestMonitoring.vue')
},
*/
];

const router = new VueRouter({
  routes
});

export default router


router.beforeEach((to, from, next) => {
  const exclude = ['Login', 'TokenStart', 'LoginWithToken', 'NetworkVideoTest','Register'];

  if (exclude.includes(to.name)) {
    next();
  } else {
    //Ensure that the assessment and all other data is reloaded from server after a browser reload.
    if (!store.getters['auth/dataIsLoadedForCurrentAuthState']) {
      store.dispatch('assessment/loadFullyAndBlock', store.state.auth.assessmentid).then(() => {
        next();
      });
    } else {
      next();
    }
  }
});
